import type { Airflow } from '@aviata/platform-types';
import type { Passenger } from '@aviata/booking-data';
import { dateUtils, citizenshipEntity, providerClassLib } from 'shared';

const mapPassengerToPayload = ({
  passenger,
  providerClass,
}: {
  passenger: Passenger;
  dateDelimiter?: string;
  providerClass?: string;
}): any => {
  const isCountryWithoutSeries =
    citizenshipEntity.config.countriesWithoutSeries.includes(
      passenger.citizenship,
    );

  const formattedPassenger = {
    first_name: passenger.firstName,
    last_name: passenger.lastName,
    gender: passenger.gender as Airflow.Gender,
    dob: dateUtils.dateToAccountsFormat(passenger.dob),
    citizenship: passenger.citizenship,
    document: {
      number: passenger.document.number,
      expires_at: passenger.document.expiresAt
        ? dateUtils.dateToAccountsFormat(passenger.document.expiresAt)
        : undefined,
    },
  };

  if (passenger.citizenship === citizenshipEntity.config.KAZAKHSTAN_CODE) {
    formattedPassenger.iin = passenger.iin;
  }

  if (providerClassLib.isFunSun(providerClass ?? '')) {
    if (passenger.citizenship === citizenshipEntity.config.AZERBAIJAN_CODE) {
      formattedPassenger.fin = passenger.fin;
    }
    if (!isCountryWithoutSeries) {
      formattedPassenger.document.series = passenger.document.series;
    }
    formattedPassenger.document.given_at = passenger.document.givenAt
      ? dateUtils.dateToAccountsFormat(passenger.document.givenAt)
      : undefined;
    formattedPassenger.document.organization = passenger.document.organization;
  }

  return formattedPassenger;
};

const convertLocalPassengersToPassengersPayload = (
  passengers: Airflow.Order.Payload.Entity['passengers'],
  providerClass?: string,
) => {
  return Object.entries(passengers).reduce(
    (acc, [key, passenger]) => ({
      ...acc,
      [key]: mapPassengerToPayload({
        passenger,
        providerClass,
      }),
    }),
    {},
  );
};

export const savePassengersLib = {
  mapPassengerToPayload,
  convertLocalPassengersToPassengersPayload,
};
